import React, { useState } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateClientRow({ generateNewRow }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    address: "",
    docName: "",
    document: ""
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const createClient = (e) => {
    e.preventDefault();

    // Clients do NOT get Firebase accounts — there are no client logins. The old
    // browser-side createUserWithEmailAndPassword (with a hardcoded password) 400s
    // now that public signup is disabled, so the save below never ran; and on success
    // it would silently re-authenticate this browser AS the newly created client.
    // POST straight to the backend; the Client schema defaults `uid` server-side, so
    // we must not send one. Failures were previously swallowed — now surfaced.
    if (!formData.firstName || !formData.lastName || !formData.email) {
      cogoToast.error("First name, last name and email are required.");
      return;
    }

    API.saveClient({
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      telephone: formData.telephone,
      address: formData.address
    })
      .then((res) => {
        cogoToast.success("Created client " + formData.firstName + " " + formData.lastName + ".");
        generateNewRow(res.data);

        if (formData.document.length > 0) {
          API.createDocumentForClient(res.data._id, {
            docName: formData.docName.length > 0 ? formData.docName : "Client Document",
            document: formData.document,
            policyid: res.data._id,
            type: "client"
          })
            .then(() => cogoToast.success("Uploaded Client Document"))
            .catch((_err) => {
              console.log(_err);
              cogoToast.error("Client created, but the document upload failed.");
            });
        }
      })
      .catch((err) => {
        console.log(err);
        cogoToast.error("Couldn't create the client. Please try again.");
      });
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({
      ...prev,
      docName: event.target.files[0].name
    }));

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          document: res
        }));
      });
    }
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.firstName}
          onChange={handleInputChange}
          name="firstName"
          autoComplete="off"
          placeholder="First Name"
        />
      </td>
      <td>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.lastName}
          onChange={handleInputChange}
          name="lastName"
          autoComplete="off"
          placeholder="Last Name"
        />
      </td>

      <td>
        <input
          style={{ width: "200px" }}
          type="text"
          value={formData.email}
          onChange={handleInputChange}
          name="email"
          autoComplete="off"
          placeholder="E-mail"
        />
      </td>

      <td>
        <input
          type="text"
          style={{ width: "200px" }}
          value={formData.telephone}
          onChange={handleInputChange}
          name="telephone"
          autoComplete="off"
          placeholder="Phone #"
        />
      </td>

      <td>
        <input
          type="text"
          style={{ width: "300px" }}
          value={formData.address}
          onChange={handleInputChange}
          name="address"
          autoComplete="off"
          placeholder="Address"
        />
      </td>

      <td>
        <input
          name="fileData"
          style={{ width: "250px" }}
          type="file"
          onChange={fileSelectedHandler}
        />
      </td>

      <td>
        <button className="btn-success btn" onClick={(e) => createClient(e)}>
          Create
        </button>
      </td>
      <td></td>
      <td></td>
    </tr>
  );
}

export default CreateClientRow;
